module.exports = __webpack_public_path__ + "img/exclamation.438493a3.svg";